// CommunitySection — T-011. Full-width photograph with the dark bottom-up
// gradient treatment, headline, and two-or-three short lines.

import type { JSX } from "react";
import { useI18n } from "../../i18n";

export function CommunitySection(): JSX.Element {
  const { t } = useI18n();
  return (
    <section
      id="community"
      aria-label="community"
      className="theme-dark-scope relative w-full overflow-hidden border-y border-[var(--color-line)]"
      style={{ minHeight: "min(60vh, 520px)" }}
    >
      <img
        className="absolute inset-0 h-full w-full object-cover"
        src="/img/community-group.webp"
        alt={t("landing.community.alt")}
        width={1376}
        height={768}
        loading="lazy"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(0deg, rgba(10,11,10,0.95) 0%, rgba(10,11,10,0.55) 40%, transparent 75%)",
        }}
      />
      <div className="relative z-10 mx-auto flex h-full max-w-[1280px] flex-col justify-end px-6 py-16 sm:px-10 md:py-20">
        <p className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-lime)]">
          {t("nav.community")}
        </p>
        <h2 className="font-display mt-2 text-4xl uppercase leading-[1.05] tracking-[0.02em] text-[var(--color-ink-hi)] sm:text-5xl">
          {t("landing.community.title")}
        </h2>
        <p
          className="mt-4 max-w-prose font-sans text-base text-[var(--color-ink)] sm:text-lg"
          style={{ lineHeight: 1.5 }}
        >
          {t("landing.community.body")}
        </p>
      </div>
    </section>
  );
}
